import { apiFetch } from './client.js';

export async function fetchMe() {
  return apiFetch('/me');
}
